import { Directive, Input, HostBinding, HostListener } from '@angular/core';

@Directive({
    selector: 'img[default]',
})
export class ImageDefaultDirective {

    @HostBinding('src')
    @Input() src: string;

    @Input() default: string;

    @HostListener('error')
    error() {
        this.src = this.default;
    }
}
